<template>
    <fade-up-animation :element="() => $refs.section">
        <div class="blog-content-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <b-row>
                        <b-col lg="10" offset-lg="1">
                            <blog-content
                                :published-at="publishedAt"
                                :content="content"
                            />
                        </b-col>
                    </b-row>
                </mobile-gutter>
            </b-container>
        </div>
    </fade-up-animation>
</template>

<script>
    import BlogContent from '../../molecules/BlogContent/BlogContent';

    export default {
        name: 'blog-content-section',

        components: { BlogContent },

        props: {
            publishedAt: {
                type: String,
                required: true,
            },

            content: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .blog-content-section {
        padding-top: 40px;
        margin-bottom: 10px;
    }
</style>
